import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import CardActions from "@material-ui/core/CardActions";
import Button from "@material-ui/core/Button";
import Logo from "../../static/titleLogo.jpg";
import CardMedia from "@material-ui/core/CardMedia";

import "./card.scss";

const useStyles = makeStyles({
  root: {
    minWidth: 275,
  },
  bullet: {
    display: "inline-block",
    margin: "0 2px",
    transform: "scale(0.8)",
  },
  title: {
    fontSize: 14,
  },
  pos: {
    marginBottom: 12,
  },
});

export default function SimpleCard(props) {
  return (
    <Grid item xs>
      <Card elevation={5} className="simpleCard">
        <div className="body">
          <CardContent>
            {props.image && <img className="image" src={props.image} />}

            <Typography color="textSecondary" gutterBottom></Typography>
            <div className="title">{props.title}</div>

            <div className="text">{props.text}</div>
            {props.link && (
              <CardActions>
                <Button href={props.link} size="small">
                  Mehr Informationen
                </Button>
              </CardActions>
            )}
          </CardContent>
        </div>
      </Card>
    </Grid>
  );
}
